<template>
  <el-scrollbar wrap-class="scrollbar-wrapper-y">
    <div>
      <div class="el-header header-container">
        <div class="header-left">
          <el-button type="success" icon="el-icon-circle-plus" @click="edit(0)"
            >创建用户</el-button
          >
        </div>
        <div class="header-right">
          <el-input
            v-model="keyword"
            @keyup.enter.native="
              currentPage = 1;
              flush();
            "
            placeholder="输入账号搜索"
          />
          <el-button
            type="primary"
            @click="
              currentPage = 1;
              flush();
            "
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        ref="multipleTable"
        :data="roleData"
        tooltip-effect="dark"
        border
        align="center"
        :stripe="true"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" align="center"></el-table-column> -->
        <el-table-column width="80" align="center" label="序号">
          <template slot-scope="scope">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="账号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="email"
          label="邮箱地址"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creator"
          label="创建人"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="roleNames"
          label="角色"
          align="center"
        ></el-table-column> -->
        <el-table-column
          property="isLockout"
          align="center"
          label="状态"
          width="120"
        >
          <template slot-scope="scope">
            <!-- <el-checkbox v-model="scope.row.aiState" disabled></el-checkbox> -->
            <el-tag v-if="!scope.row.isLockout" type="success">启用</el-tag>
            <el-tag v-else type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column label="操作" align="center" width="350">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="edit(1, scope.row)"
              >修改</el-button
            >
            <el-button
              v-if="scope.row.isLockout"
              type="success"
              size="mini"
              @click="updateLockOutStatus(scope.row.id, 1)"
              >启用</el-button
            >
            <el-button
              v-else
              type="warning"
              size="mini"
              @click="updateLockOutStatus(scope.row.id, 0)"
              >禁用</el-button
            >
            <el-button type="primary" size="mini" @click="edit(2, scope.row)"
              >重置密码</el-button
            >
            <el-button type="primary" size="mini" @click="edit(3, scope.row)"
              >分配角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page_footer_box"
        @size-change="
          currentPage = 1;
          flush();
        "
        @current-change="flush"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <PeopleEduit :config="config" @close="flush"></PeopleEduit>
    <PeopleRoleMap ref="dlg2" :config="config2" @close="flush"></PeopleRoleMap>
  </el-scrollbar>
</template>

<script>
import PeopleEduit from "../../components/dialog/PeopleEduit";
import PeopleRoleMap from "../../components/dialog/PeopleRoleMap";
import * as sysApi from "../../services/sys";
import { dateFormat } from "@/utils/utils";

export default {
  components: {
    PeopleEduit,
    PeopleRoleMap,
  },
  data() {
    return {
      roleData: [],
      account: "",
      keyword: "",
      systemSelect: "",
      show: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      config: {
        show: false,
        width: 400,
        title: "",
        type: 0, //0 创建，1 修改名称，2 重置密码
        data: {},
      },
      config2: {
        show: false,
        width: 700,
        title: "",
        type: 0, //0 创建，1 修改名称，2 重置密码
        data: {},
      },
    };
  },
  mounted() {
    this.flush();
  },
  methods: {
    async flush() {
      sysApi
        .userList({
          searchText: this.keyword,
          pageSize: this.pageSize,
          page: this.currentPage,
        })
        .then((res) => {
          res.users.map(function (item, index) {
            item.createTime = dateFormat("YYYY-mm-dd", item.createTime);
          });
          this.roleData = res.users;
          this.total = res.totalCount;
        });
    },
    handleSelectionChange(val) {
      this.selectitems = val;
    },
    async updateLockOutStatus(userid, status) {
      let _this = this;
      await this.$promission.post(
        "/api/Users/ChangeUserStatus?userId=" + userid + "&status=" + status
      );
      this.$message({
        showClose: true,
        type: "success",
        message: "操作成功!",
      });
      _this.flush();
    },
    async delRole() {
      //this.$refs.multipleTable.clearSelection()
      //this.$refs.multipleTable.toggleRowSelection(row) this.$refs.multipleTable.selection
      if (this.selectitems && this.selectitems.length) {
        await this.$confirm("确认删除所选用户?", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const ids = this.selectitems.map((item) => item.id);
        await this.$promission.post("/api/Users/Delete/" + ids);
        if (this.roleData.length == ids.length && this.currentPage)
          this.currentPage--; //全部删除返回上一页
        this.flush();
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功!",
        });
      } else {
        this.$message({
          showClose: true,
          type: "warning",
          message: "请选择要删除的用户",
        });
      }
    },
    // 用户名编辑
    async edit(type, row) {
      this.config.type = type;
      switch (type) {
        case 0:
          this.config.title = "创建用户";
          this.config.data = {
            userName: "",
            phoneNumber: "",
            email: "",
            pwd: "",
          };
          this.config.show = true;
          break;
        case 1:
          this.config.title = "修改用户信息";
          this.config.data = JSON.parse(JSON.stringify(row));
          this.config.show = true;
          break;
        case 2:
          this.config.title = `重置密码(用户：${row.userName})`;
          this.config.data = { id: row.id };
          this.config.show = true;
          break;
        case 3:
          await this.$refs.dlg2.initdata(row.id);
          this.config2.title = `分配角色(用户：${row.userName})`;
          this.config2.show = true;
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.page_footer_box {
  float: right;
  margin: 3px 10px;
}
.header-container {
  display: flex;
  justify-content: space-between;
  .header-left {
    text-align: left;
    width: 30%;
  }
  .header-right {
    text-align: right;
    width: 70%;
  }
  .role-name {
    margin-right: 8px;
    display: inline-block;
    line-height: 60px;
  }
  .el-input {
    margin-right: 8px;
    width: 60%;
  }
  .el-button--primary {
    margin-top: 10px;
    height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/sys/PeopleManagement.vue